import { InterpolatedTranslatePipe } from '@web/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent, IconName, IconPrefix } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'cas-footer-action',
  template: `
    <div class="d-flex flex-column py-4 px-5 bg-primary-dark pointer rounded">
      @let l = label() | translate;
      @if (l) {
        <p class="m-0 text-nowrap">{{ l }}</p>
      }
      <p
        class="m-0 text-nowrap"
        [class.mt-1]="l">
        <fa-icon
          class="me-2"
          [icon]="icon()" />
        <span>{{ subtitle() | translate }}</span>
      </p>
    </div>
  `,
  imports: [FaIconComponent, InterpolatedTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterActionComponent {
  readonly label = input.required<string>();
  readonly subtitle = input.required<string>();
  readonly icon = input.required<[IconPrefix, IconName]>();
}
